module.exports = __webpack_public_path__ + "img/logo2.da1c8abf.png";